<script lang="ts">
  import ShareButton from "./ShareButton.svelte";
  import Icon from "../Icon.svelte";

  export let personalLink: any = null;
  export let text: any = null;
  export let url: string;
  let href: any;

  $: href = personalLink
    ? encodeURI(`${url}`)
    : encodeURI(`https://twitter.com/intent/tweet/?text=${text}&url=${url}`);

</script>

<ShareButton {href}>
  <Icon width="32" height="32" type="TwitterCircle" />
</ShareButton>
